import lt from 'select2/src/js/select2/i18n/lt.js'

window.initializeFilterSelects = function() {
  $("[rel='user_select'], [rel='user_select_form']").each(function() {
    var field = $(this);
    var isFilter = field.attr('rel') === 'user_select';
    
    field.select2({
      placeholder: "Įrašykite vardą, pavardę",
      allowClear: false,
      minimumInputLength: 2,
      language: lt,
      dropdownParent: $('.issues-sidebar'),
      ajax: {
        url: "/users.json",
        dataType: "json",
        delay: 300,
        data: function(params) {
          return {
            q: { full_name: params.term },
            page_limit: 50
          };
        },
        processResults: function(data) {
          return {
            results: data.users.map(function(user) {
              return {
                id: user.id,
                text: user.first_name + ' ' + user.last_name
              };
            })
          };
        }
      }
    });
    
    var selectedId = field.data('selected');
    if (selectedId) {
      $.ajax({
        url: "/users.json",
        data: { q: { id_in: [selectedId] }, page_limit: 1 },
        dataType: 'json'
      }).then(function(data) {
        if (data.users && data.users.length > 0) {
          var user = data.users[0];
          var option = new Option(user.first_name + ' ' + user.last_name, user.id, true, true);
          field.append(option).trigger('change');
          
          if (isFilter && typeof window.updateIssueFilterCount === 'function') {
            window.updateIssueFilterCount();
          }
        }
      });
    }
  });

  $("[rel='member_select'], [rel='member_object_select_form']").each(function() {
    var field = $(this);
    var isFilter = field.attr('rel') === 'member_select';
    
    field.select2({
      placeholder: "Įrašykite pavadinimą",
      allowClear: false,
      minimumInputLength: 2,
      language: lt,
      dropdownParent: $('.issues-sidebar'),
      ajax: {
        url: "/finance/member_objects.json",
        dataType: "json",
        delay: 300,
        data: function(params) {
          return {
            q: { name_cont: params.term },
            page_limit: 50
          };
        },
        processResults: function(data) {
          return {
            results: data.member_objects.map(function(member_object) {
              return {
                id: member_object.id,
                text: member_object.name
              };
            })
          };
        }
      }
    });
    
    if (!isFilter) {
      var selectedId = field.data('selected');
      if (selectedId) {
        $.ajax({
          url: "/finance/member_objects.json",
          data: { q: { id_in: [selectedId] }, page_limit: 1 },
          dataType: 'json'
        }).then(function(data) {
          if (data.member_objects && data.member_objects.length > 0) {
            var member_object = data.member_objects[0];
            var option = new Option(member_object.name, member_object.id, true, true);
            field.append(option).trigger('change');
          }
        });
      }
    }
  });

  $('#filter-status, #form-status').each(function() {
    var field = $(this);
    var isFilter = field.attr('id') === 'filter-status';
    
    field.select2({
      placeholder: isFilter ? "Visos" : "Pasirinkite",
      allowClear: false,
      minimumResultsForSearch: Infinity,
      language: lt,
      dropdownParent: $('.issues-sidebar')
    });
    
    if (!isFilter) {
      field.trigger('change.select2');
    }
  });
};

$(document).ready(function() {
  let isLoading = false;

  // Toggle sidebar
  $(document).on('click', '#issues-sidebar-toggle', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const sidebar = $('#issues-sidebar');
    
    if (!sidebar.hasClass('open')) {
      if (isLoading) return;
      isLoading = true;
      
      // Load issues via AJAX
      $.ajax({
        url: '/finance/issues',
        type: 'GET',
        dataType: 'script',
        success: function() {
          sidebar.addClass('open');
          $('body').addClass('sidebar-open');
          isLoading = false;
          initializeFilterSelects();
        },
        error: function() {
          isLoading = false;
        }
      });
    } else {
      sidebar.removeClass('open');
      $('body').removeClass('sidebar-open');
    }
  });

  // Close sidebar
  $(document).on('click', '.issues-sidebar-close .close', function() {
    $('#issues-sidebar').removeClass('open');
    $('body').removeClass('sidebar-open');
  });

  // New issue button
  $(document).on('click', '#new-issue-btn', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/finance/issues/new',
      type: 'GET',
      dataType: 'script'
    });
  });

  // Back to issues list
  $(document).on('click', '#back-to-issues, #cancel-issue-form', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/finance/issues',
      type: 'GET',
      dataType: 'script'
    });
  });

  // Filter by status tabs
  $(document).on('click', '.issues-sidebar-tabs .tab-btn', function(e) {
    e.preventDefault();
    const status = $(this).data('status');
    
    $('.issues-sidebar-tabs .tab-btn').removeClass('active');
    $(this).addClass('active');
    
    const filters = {};
    if (status !== 'all') {
      filters.status = status;
    }
    
    $.ajax({
      url: '/finance/issues/filter',
      type: 'GET',
      data: filters,
      dataType: 'script'
    });
  });

  // Toggle filters
  $(document).on('click', '.filter-toggle', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.filter-content').toggleClass('open');
  });

  // Update filter count
  window.updateIssueFilterCount = function() {
    let count = 0;
    $('.filter-content select').each(function() {
      if ($(this).val() && $(this).val() !== '') {
        count++;
      }
    });
    
    const filterCount = $('.filter-count');
    if (count > 0) {
      filterCount.text(`(${count})`).show();
    } else {
      filterCount.hide();
    }
  };

  // Apply filters
  $(document).on('click', '#apply-filters', function(e) {
    e.preventDefault();
    
    const filters = {
      author_id: $('#filter-author').val(),
      user_id: $('#filter-user').val(),
      ownable_id: $('#filter-ownable').val(),
      ownable_type: $('#filter-ownable').val() ? 'Member' : '',
      status: $('#filter-status').val()
    };
    
    Object.keys(filters).forEach(key => {
      if (!filters[key] || filters[key] === '') {
        delete filters[key];
      }
    });
    
    window.updateIssueFilterCount();
    $('.filter-toggle').removeClass('active');
    $('.filter-content').removeClass('open');
    
    $.ajax({
      url: '/finance/issues/filter',
      type: 'GET',
      data: filters,
      dataType: 'script'
    });
  });

  // Clear filters
  $(document).on('click', '#clear-filters', function(e) {
    e.preventDefault();
    
    $('#filter-author').val(null).trigger('change');
    $('#filter-user').val(null).trigger('change');
    $('#filter-ownable').val(null).trigger('change');
    $('#filter-status').val('');
    
    window.updateIssueFilterCount();
    
    $.ajax({
      url: '/finance/issues/filter',
      type: 'GET',
      dataType: 'script'
    });
  });

  // Update count when select changes
  $(document).on('change', '.filter-content select', function() {
  });

  // Handle issue checkbox change (list and show page)
  $(document).on('change', '.issue-checkbox, .issue-show-checkbox', function() {
    const checkbox = $(this);
    const issueId = checkbox.data('issue-id');
    const isChecked = checkbox.is(':checked');
    const status = isChecked ? 'resolved' : 'pending';
    
    $.ajax({
      url: `/finance/issues/${issueId}`,
      type: 'PATCH',
      dataType: 'json',
      data: {
        issue: {
          status: status
        }
      },
      success: function(response) {
        const issueItem = checkbox.closest('.issue-item');
        if (issueItem.length) {
          issueItem.attr('data-status', status);
        }
      },
      error: function() {
        checkbox.prop('checked', !isChecked);
        alert('Nepavyko atnaujinti užduoties būsenos');
      }
    });
  });

  // Search issues
  let searchTimeout;
  $(document).on('keyup', '#issue-search-input', function() {
    const searchTerm = $(this).val();
    
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function() {
      $.ajax({
        url: '/finance/issues/filter',
        type: 'GET',
        data: { subject: searchTerm },
        dataType: 'script'
      });
    }, 300);
  });

  let deleteIndex = 1000;
  $(document).on('click', '.delete-comment, .delete-comment-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const commentItem = $(this).closest('.comment-item-form');
    const commentId = $(this).data('comment-id');
    const form = $(this).closest('form');
    const existingComments = commentItem.closest('.existing-comments');
    
    form.append(`<input type="hidden" name="issue[issue_comments_attributes][${deleteIndex}][id]" value="${commentId}">`);
    form.append(`<input type="hidden" name="issue[issue_comments_attributes][${deleteIndex}][_destroy]" value="1">`);
    
    deleteIndex++;
    
    commentItem.hide();
    
    const visibleComments = existingComments.find('.comment-item-form:visible');
    if (visibleComments.length === 0) {
      existingComments.hide();
      if (existingComments.siblings('.no-comments-message').length === 0) {
        existingComments.after(`
          <div class="no-comments-message">
            <i class="fas fa-comment no-comments-icon"></i>
            <p>Šiuo metu nėra komentarų.</p>
          </div>
        `);
      } else {
        existingComments.siblings('.no-comments-message').show();
      }
    }
  });

  // Close sidebar when clicking outside
  $(document).on('click', function(e) {
    const sidebar = $('#issues-sidebar');
    const toggleBtn = $('#issues-sidebar-toggle');
    
    if (sidebar.hasClass('open') && 
        !sidebar.is(e.target) && 
        sidebar.has(e.target).length === 0 &&
        !toggleBtn.is(e.target) &&
        toggleBtn.has(e.target).length === 0) {
      sidebar.removeClass('open');
      $('body').removeClass('sidebar-open');
    }
  });
});
